/** Durable native failure counts arrive with outbox refill, including at boot. */
import { whole } from "./checked_json";
let status = { held: 0, failed: 0 };
const listeners = new Set<() => void>();
export function nativeUploadStatus() { return status; }
export function updateNativeUploadStatus(held: unknown, failed: unknown): void {
  status = { held: whole(held ?? 0), failed: whole(failed ?? 0) };
  for (const listener of listeners) listener();
}
export function subscribeNativeUploadStatus(listener: () => void): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; }
